(() => {
  'use strict';
  const previewKey = new URLSearchParams(location.search).get('preview_key');
  const preservePreview = () => {
    if (!previewKey || location.pathname !== '/products_preview') return;
    setTimeout(() => {
      const url = new URL(location.href);
      url.searchParams.set('preview_key', previewKey);
      const themeId = url.searchParams.get('preview_theme_id') || String(window.Shopify?.theme?.id || '');
      if (/^[1-9][0-9]{0,24}$/.test(themeId)) url.searchParams.set('preview_theme_id', themeId);
      history.replaceState(history.state, '', url);
    }, 0);
  };
  document.addEventListener('change', preservePreview, true);
  const chooseInterior = () => {
    const root = document.querySelector('[id^="dyd-product-bundle-"]');
    const input = root && root.querySelector('input[name="dyd-current-mount"][value="Interior Mount"]');
    if (!input || root.dataset.cityInteriorReady || input.checked || root.querySelector('input[name="dyd-current-mount"]:checked')) return;
    root.dataset.cityInteriorReady = 'true';
    input.checked = true;
    input.dispatchEvent(new Event('change', {bubbles: true}));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chooseInterior, {once:true});
  else chooseInterior();
  document.addEventListener('shopify:section:load', chooseInterior);
})();

